module.exports = __webpack_public_path__ + "static/img/service4.a09ffad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/service4.png
// module id = IR8K
// module chunks = 0